<template>
  <component
    :is="programPageLayoutComponent"
    v-bind="$props"
  >
    <template #sidebar>
      <slot name="sidebar">
        <div
          v-if="enableSidebar"
          class="md:w-1/4 md:block ml-12 mb-8 hidden"
        >
          <SidebarContent />
        </div>
        <!-- Remove this block when lightcast widget is tested (and the FF below) -->
        <div
          v-else-if="lightCastWidget"
          class="md:w-1/4 md:block ml-12 mb-8 hidden"
        >
          <!-- Accounting -->
          <iframe
            id="program-widget-95a34a"
            onload="initializeScripts('program-widget-95a34a', '[https://widget.lightcastcc.com](https://widget.lightcastcc.com/)')"
            title="demo widget"
            style="border: 0; min-width: 100%; width: 1px"
            src="[https://widget.lightcastcc.com?hasCareerList=true&hasEmployment=true&hasAllLocations=true&hasImages=true&hasJobOpenings=true&hasNationalData=true&hasOutlook=true&hasSkills=true&hasVisitButton=false&hasWages=true&isHourlyWage=true&labelSet=default&clientId=demo&locationName=The%20Palouse&orderCareersBy=None&primaryColor=%233e6dcc&programs=emsi-0004&visitButtonColor=%233E6DCC&headingText=Our%20students%20can%20go%20into%20these%20careers%3A](https://widget.lightcastcc.com/?hasCareerList=true&hasEmployment=true&hasAllLocations=true&hasImages=true&hasJobOpenings=true&hasNationalData=true&hasOutlook=true&hasSkills=true&hasVisitButton=false&hasWages=true&isHourlyWage=true&labelSet=default&clientId=demo&locationName=The%20Palouse&orderCareersBy=None&primaryColor=%233e6dcc&programs=emsi-0004&visitButtonColor=%233E6DCC&headingText=Our%20students%20can%20go%20into%20these%20careers%3A)"
          ></iframe>
          <script
            type="application/javascript"
            src="https://widget.lightcastcc.com/scripts.js"
          ></script>
        </div>
        <!-- Remove this block when lightcast widget is tested (and the FF below)-->
      </slot>
    </template>
  </component>
</template>

<script>
import ProgramPageBaseLayout from '~contemporaryTheme/pages/programs/_id.baseLayout'
import ProgramPageTabLayout from '~contemporaryTheme/pages/programs/_id.tabLayout'
import useFeatureFlags from '@/composables/useFeatureFlags'
import {
  SIDEBAR,
  PROGRAM_PAGE_TAB_LAYOUT,
  LIGHTCAST_WIDGET,
} from '@/constants/featureFlags'
import SidebarContent from '@/components/contemporaryTheme/components/SidebarContent'

export default {
  setup() {
    const {
      programPageTabLayout,
      enableSidebar,
      lightCastWidget,
    } = useFeatureFlags({
      programPageTabLayout: PROGRAM_PAGE_TAB_LAYOUT,
      enableSidebar: SIDEBAR,
      lightCastWidget: LIGHTCAST_WIDGET,
    })
    return { programPageTabLayout, enableSidebar, lightCastWidget }
  },
  components: {
    SidebarContent,
  },
  props: {
    program: {
      type: Object,
      required: true,
    },
  },
  computed: {
    programPageLayoutComponent() {
      if (this.programPageTabLayout) return ProgramPageTabLayout
      return ProgramPageBaseLayout
    },
  },
}
</script>
